import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { PATHS, TERMINALS } from '../../../constants';
import { useUpdatePageGroups } from '../../../hooks';
import { SideBarPageGroups } from '../../../types/enums';
import { PageGroupProps, StyledControlledCollapse, StyledHouseIcon, StyledNavLink } from './GeneralPageGroup.styles';
import { TitleIconRow } from './TitleIconRow';

const OverviewPageGroup = ({ isExpanded }: PageGroupProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { openPageGroups, updateOpenPageGroups } = useUpdatePageGroups();

  const isOverviewCollapseOpen = isExpanded && openPageGroups.includes(SideBarPageGroups.Overview);

  return (
    <StyledControlledCollapse
      title={
        <TitleIconRow
          icon={<StyledHouseIcon $isExpanded={location.pathname.includes(TERMINALS.ParentGroups.Overview)} />}
          title={t('overview.title')}
          $isExpanded={isExpanded}
          open={isOverviewCollapseOpen}
          $isActive={location.pathname.includes(TERMINALS.ParentGroups.Overview) && isExpanded}
        />
      }
      onClick={() => updateOpenPageGroups(SideBarPageGroups.Overview)}
      open={isOverviewCollapseOpen}
      $isExpanded={isExpanded}
      $isActive={location.pathname.includes(TERMINALS.ParentGroups.Overview) && isExpanded}
    >
      <StyledNavLink to={PATHS.Overview.Home}>{t('overview.home')}</StyledNavLink>
      <StyledNavLink to={PATHS.Overview.SecurityDashboard.ROOT}>{t('securityDashboard.title')}</StyledNavLink>
      <StyledNavLink to={PATHS.Overview.Dealerships.ROOT}>{t('dealerships.title')}</StyledNavLink>
    </StyledControlledCollapse>
  );
};

export default OverviewPageGroup;
